import React from 'react';
import { Tag, FolderTree } from 'lucide-react';
import { cn } from '@/lib/utils';
import { getLengthTagInfo } from '@/lib/contentHelpers';

interface ContentTagProps {
  type: 'category' | 'keyword' | 'length';
  label: string;
  description?: string;
  className?: string;
}

export const ContentTag: React.FC<ContentTagProps> = ({ 
  type, 
  label, 
  description,
  className 
}) => {
  const baseClasses = "px-1.5 py-0.5 text-[10px] rounded-full border flex items-center gap-0.5 font-normal";
  
  const typeClasses = {
    category: "bg-blue-100 text-blue-700 border-blue-200",
    keyword: "bg-green-100 text-green-700 border-green-200",
    length: "bg-purple-100 text-purple-700 border-purple-200"
  };

  const getIcon = () => {
    if (type === 'category') {
      return <FolderTree className="h-2.5 w-2.5" />;
    } else if (type === 'keyword') {
      return <Tag className="h-2.5 w-2.5" />;
    } else {
      // For length badges, use the icon as-is from the helper function
      return getLengthTagInfo(label).icon;
    }
  };

  const icon = getIcon();

  return (
    <span 
      className={cn(baseClasses, typeClasses[type], className)}
      title={description || undefined}
    >
      {icon}
      <span>{label}</span>
    </span>
  );
};
